module.exports = __webpack_public_path__ + "static/media/plan-wom-150-gigas.457449f5.svg";